"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function ToolbarButton(props) {
    const { title, icon, onClick, onLongPress = noop_1.default, flip, selected, className, } = props;
    const theme = (0, styled_components_1.useTheme)();
    const [performingButton, setPerformingButton] = (0, react_1.useState)(false);
    const onEvent = (action) => {
        switch (action) {
            case ui_1.ActionType.SINGLE_CLICK:
                onClick();
                break;
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingButton(true);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingButton(false);
                break;
            case ui_1.ActionType.LONG_CLICK:
                /**
                 * @todo remove later
                 *
                 * Hack for legacy modes
                 */
                const toolkitActive = document.querySelector('[toolkit-active]');
                if (!toolkitActive) {
                    onLongPress();
                }
                break;
        }
    };
    const [handlers] = (0, ui_1.useLongPressHandlers)(onEvent);
    const IconElement = flip ? StyledIconFlip : StyledIcon;
    return ((0, jsx_runtime_1.jsxs)(Button, Object.assign({ selected: selected, className: className, onClick: () => { } }, handlers, { "data-e2e": 'ToolbarButton_Button', children: [(0, jsx_runtime_1.jsx)(IconContainer, { "$performingMouseDown": performingButton, "data-e2e": 'ToolbarButton_IconContainer', children: (0, jsx_runtime_1.jsx)(IconElement, { name: icon, "data-e2e": 'ToolbarButton_IconElement' }) }), (0, jsx_runtime_1.jsx)(Label, { "data-e2e": 'ToolbarButton_Label', children: title }), (0, jsx_runtime_1.jsx)(ui_1.Ripple, { color: theme.ripple, duration: 700, "data-e2e": 'ToolbarButton_Ripple' })] })));
}
exports.default = ToolbarButton;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  position: relative;

  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: min-content;
  min-width: 50px;
  height: 100%;
  margin: 0;
  padding: 0;

  color: ${props => props.theme.textSecondary};

  background: ${props => props.selected
    ? props.theme.gray
    : props.theme.navigationToolbar.background};

  transition: background 0.2s ease-in-out, transform 0.125s ease-in-out;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    margin-left: 5px;
    padding-right: 3px;
  `)}

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    flex-direction: column;
    margin-left: 0;
    padding-right: 0;
  `)}
  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-direction: column;
    margin-left: 0;
    padding-right: 0;
  `)}
`;
const IconContainer = styled_components_1.default.div `
  margin: 6px auto auto;
  transform: ${({ $performingMouseDown }) => $performingMouseDown ? 'scale(0.9)' : 'scale(1)'};

  transition: transform 0.125s ease-in-out;

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    margin: auto auto 0;
  `)}
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 100%;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    height: 16px;
  `)}
  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    height: 25px;
  `)}
  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 25px;
  `)}

  margin: auto auto 0;
`;
const StyledIconFlip = (0, styled_components_1.default)(StyledIcon) `
  transform: scaleX(-1);
`;
const Label = styled_components_1.default.div `
  margin: 2px auto auto;

  font-size: 11px;
  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    margin: auto auto 2px;
  `)}
`;
